import {MeshState} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshState';
import {NestedSheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/NestedSheet';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {SpreadsheetTabsState} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SpreadsheetTabsState';
import {SheetId, WorkbookId} from '@mintdata/mint-kit/api/models/Identifiers';
import {FramePath} from '@mintdata/mint-kit/api/values/frames/Frame';
import {observable} from 'mobx';
import {MeshInputState} from './spreadsheet/MeshInputState';

export type FrameDetailsEntryKey = string;

export class FrameDetailsEntry
{
    public constructor(public readonly key:FrameDetailsEntryKey,
                       public readonly workbookId:WorkbookId,
                       public readonly mainSheetId:SheetId,
                       public readonly mainSheetSlotLocation:SlotLocation,
                       public readonly pathInFrame:FramePath,
                       public readonly sheet:NestedSheet,
                       public readonly meshState:MeshState,
                       public readonly isStub:boolean = false)
    {
    }
}

export class SpreadsheetPerTabViewState
{
    @observable public frameDetailsStack:FrameDetailsEntry[] = [];
}

export class SpreadsheetEditorState
{
    @observable isEditMode:boolean = false;
    @observable editSheetId:string = null;
    @observable isShowCellRefHint: boolean;
    
    @observable
    public input:MeshInputState = new MeshInputState();

    public readonly tabs:SpreadsheetTabsState = new SpreadsheetTabsState();

    @observable public readonly perTab:Map<SheetId, SpreadsheetPerTabViewState> = new Map();
}
